module.exports = __webpack_public_path__ + "img/modelo_sierra.25e9e461.png";